import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { userStore } from "../store/Store";

export default function FullAccess() {
  const context = useOutletContext()
  const currentCompany = userStore((data) => data.currentCompany);

  if (!currentCompany) {
    return <Navigate to="/login" replace />;
  }

  if (!currentCompany.full_access) {
    return <Navigate to="/account-invoices/received" replace />;
  }

  return <Outlet context={context}/>;
}
